import dayjs from 'dayjs';

//hooks
import useUser from '@/utils/hooks/swr/useUser';

import PropTypes from 'prop-types';

//lib
import userDateFormat from '@/lib/user/dateFormat';

// Custom component for table report NEXT DELIVERY Column
const NextDeliveryCell = ({ value }) => {
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    const datesFormatted = dayjs(value).format(
        userDateFormat[user?.settings?.date_format] ?? 'YYYY-MM-DD'
    );
    return (
        <span className="leading-wide rounded-m bg-icoGray-100 px-3 py-2 text-xs text-icoGray-500 dark:bg-icoDarkMode-anthracite dark:text-icoDarkMode-wolf">
            {datesFormatted}
        </span>
    );
};

NextDeliveryCell.propTypes = {
    value: PropTypes.string.isRequired
};

export default NextDeliveryCell;
